import React from 'react';
import {
    Card, SimpleTable,
} from 'components';
import { connect } from 'react-redux';
import { useLocalErrorHandler } from 'hooks';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useHistory } from 'react-router';
import {formatQualification} from "_helpers";

const QualificationsListContainer: React.FC<Props> = (
  {
      setErrorHandler,
      fetchProfile,
      apiError,
      qualificationList,
  },
) => {
    useLocalErrorHandler(setErrorHandler);
    const { push } = useHistory();

    React.useEffect(() => {
        fetchProfile();
    }, []);
    

    return (
        <Card
          title="Специальности АЦ"
          category="Список специальностей аккредитационного центра"
          cardClassName="position-relative"
          apiError={apiError}
          withoutBorder
          withoutPadding
        >
            <SimpleTable
                tableRows={qualificationList.map(q => ({
                    id: q.id,
                    columns: [formatQualification(q), q.audienceCapacity],
                }))}
                tableHeaders={[{ title: 'СПЕЦИАЛЬНОСТЬ' }, { title: 'ВМЕСТИМОСТЬ (ЧЕЛ./ДЕНЬ)' }]}
                handleRowClick={() => true}
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    qualificationList: state.general.info ? state.general.info.qualifications : [],
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    fetchProfile: dispatch.general.getInfoAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(QualificationsListContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
